// Global application settings

export const season = '20262027'; // used for headshots